module.exports = __webpack_public_path__ + "static/media/buddy_jesus.aef776b2.png";